// src/features/workflows/ClosureOfferPanel.jsx
//
// W4 — CLOSURE-WF-REACTIVE-LAUNCH
//
// Post-vacate offer panel surfaced on the location overview after a
// successful stage-change to "Vacated". Accepts/Dismiss callbacks are
// handled by LocationDetail; this component is purely presentational.
//
// Props:
//   locationAlias  — display name for the vacated office
//   onAccept       — called when the user clicks "Start closure run"
//   onDismiss      — called when the user clicks "Dismiss"

import React from "react";
import { T } from "../../app/tokens.js";

export function ClosureOfferPanel({ locationAlias, onAccept, onDismiss }) {
  return (
    <div
      data-testid="closure-offer-panel"
      style={{
        background: T.blueSoft,
        border: `1px solid ${T.blue}`,
        borderRadius: 9,
        padding: "12px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        marginBottom: 14,
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: T.fsSm5, fontWeight: T.fwBold, color: T.dark }}>
          This office was vacated
        </div>
        <div style={{ fontSize: T.fsXs, color: T.mid, marginTop: 2 }}>
          Start the Office Closure / Relocation workflow
          {locationAlias ? ` for ${locationAlias}` : ""}?
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
        <button
          type="button"
          data-testid="closure-offer-accept"
          onClick={onAccept}
          style={{
            background: T.blue,
            color: T.white,
            border: "none",
            borderRadius: 7,
            padding: "6px 14px",
            fontSize: T.fsXs,
            fontWeight: T.fwBold,
            cursor: "pointer",
          }}
        >
          Start closure run
        </button>
        <button
          type="button"
          data-testid="closure-offer-dismiss"
          onClick={onDismiss}
          style={{
            background: "transparent",
            color: T.mid,
            border: "none",
            fontSize: T.fsXs,
            cursor: "pointer",
            textDecoration: "underline",
            padding: "4px 2px",
          }}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}

// ─── ClosureOfferChip ──────────────────────────────────────────────────────────
//
// Compact persistent action chip shown after the user dismisses the full panel.
// Clicking re-triggers the same onAccept flow.

export function ClosureOfferChip({ onAccept }) {
  return (
    <button
      type="button"
      data-testid="closure-offer-chip"
      onClick={onAccept}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        background: "transparent",
        border: `1px solid ${T.blue}`,
        borderRadius: 999,
        padding: "3px 10px",
        fontSize: T.fsXs,
        fontWeight: T.fwSemibold,
        color: T.blue,
        cursor: "pointer",
        marginBottom: 10,
      }}
    >
      Start closure run →
    </button>
  );
}
